import React from 'react'

export default function LayoutsDataEntry(props) {
  return (

    <section><a className="anchor" id="grid"></a>
      <div className="push--bottom grid">
          <div className="grid__col-sm-12  grid__col-lg-6">
              <a href="samples/grid.html"><img src="images/grid.png" alt="Screenshot of the grid samples" className="media__img"/></a>
          </div>
          <div className="media__body soft--top grid__col-sm-12  grid__col-lg-6">
            <h1>Grid Showcase</h1>
            Example of using -
            <ul>
              <li><a href={props.staticVersion === true ? '#core/forms' : 'Core#forms'}>Forms</a></li>
              <li><a href={props.staticVersion === true ? '#core/grid' : 'Core#grid'}>Grid</a></li>
            </ul>
            <p><a className="btn btn--large" href="samples/grid.html">View live preview</a>&nbsp;<a className="btn btn--large" href="samples/grid.html" download>Download</a></p>
          </div>
      </div>
    </section>
  )
}



// WEBPACK FOOTER //
// ./styleguide/components/sections/LayoutsGrid.js